export const SIZES = {
  small: 'Small',
  medium: 'Medium',
} as const;
export const sizes = Object.values(SIZES);
